import { CompanyAndDepartment } from '../../../shared/models/company-and-department.model';
import { Sponsor } from '../../shared/models/sponsor.model';

export class AuctionItemDto {
  Id: number;
  ClubId: number;
  AdminId: number;
  CategoryId: number;
  ItemName: string;
  ItemDescription: string;
  /**
   * The minimum bid required to start the auction.
   */
  PointsValue: number;
  StartDate: Date | string;
  EndDate: Date | string;
  AllowSelfBid: boolean;
  AdditionalTime: number;
  PeriodOfExtend: number;
  ResetCounter: boolean;
  TestOnly: boolean;
  Favourite: number;
  ComingSoon: boolean;
  ItemPopulationType: number;
  CreationDate: Date | string;
  StatusDescription: string;
  GameNumber: number;
  SectionId: number;
  Ordinal: number;
  EmailCategoryId: number;
  DepartmentId: number;
  CompanyId: number;
  CompanyAndDepartment: CompanyAndDepartment;
  ImageUrl: string;
  ThumbnailURL: string;
  Deleted: boolean;
  LastUpdated: Date | string;
  /**
   * The minimum increase to the current bid amount a bid can be.
   */
  BidIncrement: number;
  RequestTime: Date | string;
  BidsCount: number;
  TransactionDescriptionText: string;
  ItemState: number;
  AvailableCount: number;
  AvailabilityCount: number;
  UserLastBid: number;
  /**
   * The current points value of the top bid. Will be set to the starting value if no bids yet.
   */
  CurrentValue: number;
  CustomerState: number;
  IsDatabaseTimeSet: boolean;
  IsAdminUser: boolean;
  Sponsor: Sponsor;
}
